import http from 'plugins/axios'

export default {
  //之前的获取用户列表
  // getUserList({
  //   page = 1,
  //   size = 25,
  //   queryType,
  //   queryValue,
  //   userStatus,
  //   userType,
  //   mark
  // }) {
  //   return http.get({
  //     url: `/la/admin/trade/user/${page}/${size}`,
  //     data: {
  //       queryType,
  //       queryValue,
  //       userStatus,
  //       userType,
  //       mark
  //     }
  //   });
  // },
  //更新后的查询所有用户信息
  getUserList(params) {
    return http.get({
      url: `/la/admin/rebate/examineList`,
      params,
    })
  },

  // 通过审核
  auditing({ rebateId, status }) {
    return http.post({
      url: `/la/admin/rebate/passOrRefuse?rebateId=${rebateId}&status=${status}`,
    })
  },
  // 升级合伙人
  upgradePartner({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/addChannel?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    })
  },
  // 设置返佣比例
  upgradeRate({ userId, channelId, rate }) {
    return http.post({
      url: `/channel/partner/rebateRate?channelId=${channelId}&userId=${userId}&rate=${rate}`,
    })
  },

  getExcelData(data) {
    return http.get({
      url: '/la/admin/rebate/listExport',
      data,
      responseType: 'blob',
    })
  },
}
